/**
 * Created by mark on 17/12/2017.
 */

import BaseStore from './base-store.js';
import Constants from '../constants.js';
var _registerToActions = function(action){

    switch(action.actionType)
    {
        case Constants.GET_ACCOUNT_STAFF:
            this.staff =  action.response;
            this.emit(Constants.GET_ACCOUNT_STAFF);
            break;
        case Constants.GET_ACCOUNT_STUDENTS:
            this.students =  action.response;
            this.emit(Constants.GET_ACCOUNT_STUDENTS);
            break;
        case Constants.GET_ACCOUNT:
            this.account =  action.response;
            this.emit(Constants.GET_ACCOUNT);
            break;
        case Constants.GET_PRODUCT_FEATURES:
            this.productFeatures =  action.response.features;
            this.emit(Constants.GET_PRODUCT_FEATURES);
            break;
        case Constants.GET_CURRICULUM_DATA:
            this.curriculumData =  action.response;
            this.emit(Constants.GET_CURRICULUM_DATA);
            break;
    }

};
    
class AccountStore extends BaseStore{

    constructor(){
        super();
        this.subscribe(() => _registerToActions.bind(this));
        this.yearGroups =  [];
        this.productFeatures = [];
        this.curriculumData = [];
        this.activeAccountID = null;
        this.information = {}
    }

    setAccount(accountUID) {
        this.activeAccountID = accountUID
    }

    get() {
        return this.account || {};
    }

    getProductFeatures() {
        return this.productFeatures;
    }

    getCurriculumData() {
        return this.curriculumData;
    }
}

export default new AccountStore();